import i18next from 'i18next'
import moment from 'moment'

export const executeCode = (code: string, data: Record<string, unknown>): unknown | false => {
  try {
    // Глобальный контекст для всех скриптов: moment + переданные данные
    const mergedData = { moment, ...data }
    const func = new Function(...Object.keys(mergedData), code)

    return func(...Object.values(mergedData || {}))
  } catch (error) {
    console.error(i18next.t('executeCodeError'), error) // Логирование ошибки

    // TODO Возможны проблемы с boolean значениями
    return false
  }
}
